import { FC, useEffect, useRef } from 'react'
import styled, { useTheme } from 'styled-components'

import { TypeStyle, Warning } from '@syconium/little-miss-figgy'

type CartErrorMessageProps = {
  errorMessage: string
  /**
   * `scrollToError` should only be used for PDP-type pages, not for QuickBuy
   */
  scrollToError?: boolean
}

export const CartErrorMessage: FC<CartErrorMessageProps> = ({
  errorMessage,
  scrollToError = false,
}) => {
  const { color } = useTheme()
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!scrollToError) return
    requestAnimationFrame(() => {
      containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      containerRef.current?.focus({ preventScroll: true })
    })
  }, [scrollToError])

  if (errorMessage.length === 0) return null

  return (
    <Container ref={containerRef} tabIndex={-1} role='alert' aria-live='polite'>
      <IconWrapper>
        <Warning width={14} height={16} fill={color.text.critical.on.background} />
      </IconWrapper>
      <Message>{errorMessage}</Message>
    </Container>
  )
}

const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
`

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.color.stroke.critical.text.on.background};
  scroll-margin-top: 140px; // places viewport with ATB button and error message in view
`

const Message = styled(TypeStyle.BodyNano)`
  font-weight: 600;
`
